import { TranslationMap } from '@trimble-gcs/i18n-types';

export function connectPanelTranslations() {
  return {
    refreshing: {
      button: {
        text: $localize`:@@connectPanelStatus.refreshing.button:Loading ...`,
        desc: 'Text of the "Loading" button in the Connect explorer.',
      },
      message: {
        text: $localize`:@@connectPanelStatus.refreshing.message:Checking file status`,
        desc: 'Message displayed with the "Loading" button in the Connect explorer.',
      },
    },
    regionNotSupported: {
      message: {
        text: $localize`:@@connectPanelStatus.regionNotSupported.message:Region not supported.`,
        desc: 'Message displayed with the "Region not supported" message in the Connect explorer.',
      },
    },
    ingestionError: {
      button: {
        text: $localize`:@@connectPanelStatus.ingestionError.button:Refresh`,
        desc: 'Text of the "Refresh" button in the Connect explorer.',
      },
      message: {
        text: $localize`:@@connectPanelStatus.ingestionError.message:Ingestion error.\nClick refresh to update status.`,
        desc: 'Message displayed with the "Refresh" button in the Connect explorer when an ingestion error ocurred.',
      },
    },
    insufficientPermission: {
      button: {
        text: $localize`:@@connectPanelStatus.insufficientPermission.button:Tile`,
        desc: 'Text of the "Tile" button in the Connect explorer.',
      },
      message: {
        text: $localize`:@@connectPanelStatus.insufficientPermission.message:Insufficient permission to tile this file.`,
        desc: 'Message displayed with the "Tile" button in the Connect Explorer when the user has insufficient permissions to the current project.',
      },
    },
    noActiveLicense: {
      button: {
        text: $localize`:@@connectPanelStatus.noActiveLicense.button:Tile`,
        desc: 'Text of the "Tile" button in the Connect explorer.',
      },
      message: {
        text: $localize`:@@connectPanelStatus.noActiveLicense.message:Could not find an active license for this project.`,
        desc: 'Message displayed with the "Tile" button in the Connect Explorer when there is no active license for the current project.',
      },
    },
    quotaExceeded: {
      button: {
        text: $localize`:@@connectPanelStatus.quotaExceeded.button:Tile`,
        desc: 'Text of the "Tile" button in the Connect explorer.',
      },
      message: {
        text: $localize`:@@connectPanelStatus.quotaExceeded.message:Quota will be exceeded. Looks like you have run out of space. Clean up your data by deleting or archiving, alternatively, contact your license administrator to upgrade.`,
        desc: 'Message displayed with the "Tile" button in the Connect Explorer when the storage quota has been exceeded for the current project.',
      },
    },
    readyToRefresh: {
      button: {
        text: $localize`:@@connectPanelStatus.readyToRefresh.button:Refresh`,
        desc: 'Text of the "Refresh" button in the Connect explorer.',
      },
      message: {
        text: $localize`:@@connectPanelStatus.readyToRefresh.message:File tiling is busy processing.\nClick refresh to update status.`,
        desc: 'Message displayed with the "Refresh" button in the Connect Explorer when the selected file is being tiled.',
      },
    },
    readyToTile: {
      button: {
        text: $localize`:@@connectPanelStatus.readyToTile.button:Tile`,
        desc: 'Text of the "Tile" button in the Connect explorer.',
      },
      message: {
        text: $localize`:@@connectPanelStatus.readyToTile.message:This point cloud is not tiled and cannot be viewed right now, click on button above to get this process started.`,
        desc: 'Message displayed with the "Tile" button in the Connect Explorer when the selected file is ready to be tiled.',
      },
    },
    readyToTileNewVersion: {
      button: {
        text: $localize`:@@connectPanelStatus.readyToTileNewVersion.button:Tile`,
        desc: 'Text of the "Tile" button in the Connect explorer.',
      },
      message: {
        text: $localize`:@@connectPanelStatus.readyToTileNewVersion.message:This point cloud is not tiled for the current version of the file, click on button above to get this process started.`,
        desc: 'Message displayed with the "Tile" button in the Connect Explorer when a new version of the selected file is ready to be tiled.',
      },
    },
    readyToViewIn3d: {
      button: {
        text: $localize`:@@connectPanelStatus.readyToViewIn3d.button:View in 3D`,
        desc: 'Text of the "View in 3D" button in the Connect explorer.',
      },
    },
    tiling: {
      button: {
        text: $localize`:@@connectPanelStatus.tiling.button:Loading ...`,
        desc: 'Text of the "Loading" button in the Connect explorer.',
      },
      message: {
        text: $localize`:@@connectPanelStatus.tiling.message:Started tiling process`,
        desc: 'Message displayed with the "Loading" button in the Connect Explorer when tiling is in progress for the selected file.',
      },
    },
    tilingError: {
      button: {
        text: $localize`:@@connectPanelStatus.tilingError.button:Tile`,
        desc: 'Text of the "Tile" button in the Connect explorer.',
      },
      message: {
        text: $localize`:@@connectPanelStatus.tilingError.message:Tiling failed. Please try again.`,
        desc: 'Message displayed with the "Tile" button in the Connect Explorer when tiling of the selected file has failed.',
      },
    },
    viewing: {
      button: {
        text: $localize`:@@connectPanelStatus.viewing.button:Loading...`,
        desc: 'Text of the "Loading" button in the Connect explorer.',
      },
      message: {
        text: $localize`:@@connectPanelStatus.viewing.message:Opening Connect 3D`,
        desc: 'Message displayed with the "View" button in the Connect Explorer when a file has been selected that is ready for viewing in the 3D viewer.',
      },
    },
  } satisfies TranslationMap;
}
